<template>
  <div class="reminders bg-white-1 shadow3 border-radius-sm q-pa-lg relative-position">
    <q-inner-loading :showing="loading" style="z-index: 2">
      <q-spinner color="secondary-1" size="2rem" />
    </q-inner-loading>

    <div class="text-subtitle-1 text-secondary-2">DECISION DEADLINE REMINDERS</div>

    <GridTable :columns="columns" :rows="data" mode="ag-grid" class="q-mt-lg">
      <template #row="{row}">
        <GridTableCell no-tooltip>
          <router-link
            :to="`/subscriptions/${row.entity.id}`"
            class="text-body-1 text-link-blue"
            style="text-decoration: none"
          >
            {{ row.entity.name }}
          </router-link>
        </GridTableCell>

        <GridTableCell class="text-center">{{ formatDateForLocale(row.entity.cancellation_deadline) }}</GridTableCell>

        <GridTableCell class="text-center" no-tooltip>
          <RBtn type="ghost" size="small" @click="dismiss(row.id)">dismiss</RBtn>
        </GridTableCell>
      </template>
    </GridTable>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  components: {
    GridTable,
    GridTableCell
  },

  data: () => ({
    data: null,
    loading: false
  }),

  computed: {
    columns() {
      return [
        { label: 'Subscription', width: '1fr' },
        { label: 'Decision deadline', width: '115px', align: 'center' },
        { label: '', width: '75px', align: 'center' }
      ]
    }
  },

  created() {
    apiTo.GET_CANCELLATION_REMINDERS().then(({ data }) => (this.data = data.result))
  },

  methods: {
    dismiss(rowId) {
      this.loading = true

      apiTo
        .DELETE_REMINDER(rowId)
        .then(() => {
          const index = this.data.findIndex(row => row.id === rowId)

          if (~index) this.data.splice(index, 1)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss">
.reminders {
  isolation: isolate;
}
</style>
